import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const PdfPreviewModal = ({ isOpen, title, pdfUrl, fileName, onClose }) => {
  const downloadPdf = () => {
    if (!pdfUrl) {
      return;
    }

    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = fileName || 'RezRATE_Print_Materials.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal isOpen={isOpen} centered={true} style={{ maxWidth: '92%', width: '92%' }} zIndex={9999} toggle={onClose}>
      <ModalHeader toggle={onClose}>{title || 'PDF Preview'}</ModalHeader>
      <ModalBody style={{ padding: 0 }}>
        {pdfUrl ? (
          <div style={{ height: '78vh', background: '#f5f5f5' }}>
            <iframe
              title={title || 'PDF Preview'}
              src={pdfUrl}
              style={{ width: '100%', height: '100%', border: 'none', background: '#fff' }}
            />
          </div>
        ) : (
          <div style={{ padding: 24 }}>No PDF preview available.</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="success" disabled={!pdfUrl} onClick={downloadPdf}>
          Download PDF
        </Button>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PdfPreviewModal;
